export default {"src":"/_next/static/media/side_panel_icon.aac15e99.svg","height":156,"width":187,"blurWidth":0,"blurHeight":0};